import { SVGProps } from 'react'

const CloseIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 7.48 7.48"
    className={className}
    {...props}
  >
    <defs>
      <style>
        {
          '.cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'
        }
      </style>
    </defs>
    <title>{'icon--close'}</title>
    <path
      d="m1.803 5.677 3.874-3.874M1.803 1.803l3.874 3.874"
      className="cls-1"
    />
  </svg>
)
export default CloseIcon
